module.exports = __webpack_public_path__ + "static/media/piggy_bank.d5b9c21b.png";